import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "ColorLinkList",
    component: () => (__SERVER__ ? require("./color-link-list-view") : import("./color-link-list-view"))
});

export default definition;
